import { Room } from "./../../../models/room";
import { CALL_STATES, SUB_BUTTON_ACTIONS } from "./../../../constants";

const handleCallAction = (type, sessionContext, handleToggleActiveButtonActions, enabled, handleSetActiveState, handleUpdateActiveToken, handleClearFrame) =>{
    switch(type){
        case SUB_BUTTON_ACTIONS.MUTE:
            return async() => {
                    const roomInstance = Room.getInstance().getRoomInstance();
                    if (!roomInstance) return;
                    await roomInstance.localParticipant.setMicrophoneEnabled(!enabled);
                    handleToggleActiveButtonActions(SUB_BUTTON_ACTIONS.MUTE, enabled);
                }
        case SUB_BUTTON_ACTIONS.HOLD:
            return async() => {
                    const roomInstance = Room.getInstance().getRoomInstance();
                    if (!roomInstance) return;
                    await roomInstance.localParticipant.setMicrophoneEnabled(!enabled);
                    handleToggleActiveButtonActions(SUB_BUTTON_ACTIONS.HOLD, enabled);
            }
        case SUB_BUTTON_ACTIONS.END:
            return async() => {
                const roomInstance = Room.getInstance().getRoomInstance();
                if (!roomInstance) return;
                await roomInstance.disconnect();
                handleToggleActiveButtonActions(SUB_BUTTON_ACTIONS.END, enabled);
                handleSetActiveState?.(CALL_STATES.ENDED);
                handleUpdateActiveToken("");
                handleClearFrame();
            };
        default:
            return ()=>{};
    }
}

const handlePopulateActionButtons = (
    actionButtonProps,
    sessionContext,
    handleToggleActiveButtonActions,
    enabled,
    handleSetActiveState,
    handleUpdateActiveToken,
    handleClearFrame
) => {
    const buttonActions: any = {};
    Object.keys(actionButtonProps.actions).forEach((actionKey) => {
        buttonActions[actionKey] = handleCallAction(
            actionButtonProps.actions[actionKey],
            sessionContext,
            handleToggleActiveButtonActions,
            enabled,
            handleSetActiveState,
            handleUpdateActiveToken,
            handleClearFrame
        );
    });
    return {
        ...actionButtonProps,
        actions: buttonActions,
    };
};

export {
    handleCallAction,
    handlePopulateActionButtons
}